import { memo } from 'react'
import NextLink from 'next/link'

import { Link, List, ListItem } from '@mui/material'

import { getTarget } from '@/helpers/getTarget'
import { getHighlightedLinkStyle } from '@/helpers/linkColors'
import { useHeaderContext } from '@/hooks/useHeaderContext'

import type { FC } from 'react'
import type { NavigationNode } from '@/interfaces/NavigationNode'

interface ColumnLinksProps {
  links: NavigationNode[]
  colIndex: number
  parentId: string
}

const ColumnLinks: FC<ColumnLinksProps> = ({ links, colIndex, parentId }) => {
  const { toggleIsMegaMenuOpen } = useHeaderContext()

  return (
    <List>
      {links.map((link, index) => (
        <ListItem disableGutters disablePadding key={link.id}>
          <Link
            component={NextLink}
            prefetch={false}
            href={link.href ?? '#'}
            {...getTarget(link.openInNewTab)}
            style={getHighlightedLinkStyle(link)}
            onClick={toggleIsMegaMenuOpen(false, null, true)}
            underline="hover"
            variant="body1"
            data-parent-id={parentId}
            data-col-index={colIndex}
            data-row-index={index + 1}
            marginBottom={0.5}
          >
            {link.title}
          </Link>
        </ListItem>
      ))}
    </List>
  )
}

export default memo(ColumnLinks)
